import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Share2, Link2, Mail, Facebook, Check } from 'lucide-react';
import { toast } from 'sonner';

// Custom SVG icons for platforms not in lucide-react

const WhatsAppIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="#25D366">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const XIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.738l7.726-8.851L1.5 2.25h7.433l4.25 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="url(#ig-grad)">
    <defs>
      <linearGradient id="ig-grad" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#f09433"/>
        <stop offset="25%" stopColor="#e6683c"/>
        <stop offset="50%" stopColor="#dc2743"/>
        <stop offset="75%" stopColor="#cc2366"/>
        <stop offset="100%" stopColor="#bc1888"/>
      </linearGradient>
    </defs>
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const TikTokIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.84a8.23 8.23 0 0 0 4.83 1.56V7.04a4.85 4.85 0 0 1-1.07-.35z"/>
  </svg>
);

export default function ShareButton({
  url,
  title,
  description,
  type = 'listing',
  variant = 'default',
  size = 'default'
}) {
  const { t } = useLanguage();
  const [copied, setCopied] = useState(false);

  const shareUrl = url || window.location.href;
  const shareTitle = title || 'Check out this property on TLA Housing Europe!';
  const shareDescription = description || 'Found this great TLA-compliant property for military families.';

  const copyToClipboard = async (label) => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success(label || t('share.link_copied', 'Link copied to clipboard!'));
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error(t('share.copy_failed', 'Failed to copy link'));
    }
  };

  const handleCopyLink = () => copyToClipboard(t('share.link_copied', 'Link copied to clipboard!'));

  const handleWhatsAppShare = () => {
    const text = `${shareTitle}\n\n${shareDescription}\n\n${shareUrl}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank');
  };

  const handleEmailShare = async () => {
    const subject = encodeURIComponent(shareTitle);
    const body = encodeURIComponent(`${shareDescription}\n\nCheck it out here: ${shareUrl}`);
    try { await navigator.clipboard.writeText(shareUrl); } catch { /* clipboard optional */ }
    window.open(`mailto:?subject=${subject}&body=${body}`, '_blank');
    toast.info(t('share.email_fallback', 'Opening email app. If nothing opens, the link has been copied.'));
  };

  const handleFacebookShare = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shareTitle)}`,
      '_blank',
      'width=600,height=400'
    );
  };

  const handleXShare = () => {
    const text = `${shareTitle} ${shareUrl}`;
    window.open(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`,
      '_blank',
      'width=600,height=400'
    );
  };

  const handleInstagramShare = () =>
    copyToClipboard(t('share.copied_instagram', 'Link copied — paste it into Instagram.'));

  const handleTikTokShare = () =>
    copyToClipboard(t('share.copied_tiktok', 'Link copied — paste it into TikTok.'));

  const hasNativeShare = typeof navigator !== 'undefined' && navigator.share;

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant={variant}
          size={size}
          className={variant === 'default' ? 'bg-slate-800 hover:bg-slate-700 text-slate-200' : ''}
          data-testid="share-button"
        >
          <Share2 className="w-4 h-4 mr-2" />
          {t('share.share', 'Share')}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-white border-slate-200 w-52" align="end">
        {hasNativeShare && (
          <DropdownMenuItem
            onClick={() => navigator.share({ title: shareTitle, text: shareDescription, url: shareUrl }).catch(() => {})}
            className="text-slate-700 hover:text-slate-900 hover:bg-slate-100 cursor-pointer"
          >
            <Share2 className="w-4 h-4 mr-3 text-signal-blue" />
            {t('share.native', 'Share...')}
          </DropdownMenuItem>
        )}

        <DropdownMenuItem
          onClick={handleCopyLink}
          className="text-slate-700 hover:text-slate-900 hover:bg-slate-100 cursor-pointer"
        >
          {copied ? (
            <Check className="w-4 h-4 mr-3 text-emerald-500" />
          ) : (
            <Link2 className="w-4 h-4 mr-3 text-slate-500" />
          )}
          {copied ? t('share.copied', 'Copied!') : t('share.copy_link', 'Copy Link')}
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={handleWhatsAppShare}
          className="text-slate-700 hover:text-slate-900 hover:bg-slate-100 cursor-pointer"
        >
          <WhatsAppIcon />
          <span className="ml-3">WhatsApp</span>
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={handleXShare}
          className="text-slate-700 hover:text-slate-900 hover:bg-slate-100 cursor-pointer"
        >
          <XIcon />
          <span className="ml-3">{t('share.twitter', 'X / Twitter')}</span>
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={handleInstagramShare}
          className="text-slate-700 hover:text-slate-900 hover:bg-slate-100 cursor-pointer"
        >
          <InstagramIcon />
          <span className="ml-3">{t('share.instagram', 'Instagram')}</span>
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={handleTikTokShare}
          className="text-slate-700 hover:text-slate-900 hover:bg-slate-100 cursor-pointer"
        >
          <TikTokIcon />
          <span className="ml-3">{t('share.tiktok', 'TikTok')}</span>
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={handleEmailShare}
          className="text-slate-700 hover:text-slate-900 hover:bg-slate-100 cursor-pointer"
        >
          <Mail className="w-4 h-4 mr-3 text-slate-500" />
          {t('share.email', 'Email')}
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={handleFacebookShare}
          className="text-slate-700 hover:text-slate-900 hover:bg-slate-100 cursor-pointer"
        >
          <Facebook className="w-4 h-4 mr-3 text-[#1877F2]" />
          Facebook
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
